import Styleguide from "@store/Framework/Types/Styleguide";

const focus: Styleguide["focus"] = {
    offset: "0",
};

export default focus;
